import { ArnI18nServiceFactory } from './ArnI18nServiceFactory';
import { ArnValidI18nConfig, UrlUtil } from '@arianee/arn-types';
import { ArnHttpI18nConfig, ArnI18nConfig } from './ArnI18nConfig';
import { ArnHttpI18nService } from './ArnHttpI18nService';
import { ArnHttpService } from '../http';
import { ArnI18nService } from './ArnI18nService';

/**
 * Creates internationalization (i18n) service and default configuration.
 */
export class ArnHttpI18nServiceFactory implements ArnI18nServiceFactory {
  createConfig(spec?: ArnI18nConfig, baseUrl?: string): ArnValidI18nConfig {
    return new ArnHttpI18nConfig(
      UrlUtil.build(spec?.url, 'i18n/', baseUrl),
      spec?.defaultLang || 'en',
      spec?.lang || ['en']
    );
  }

  /**
   * Creates a configuration with defaults applied where appropriate,
   * then creates an I18n client service with this valid configuration.
   *
   * @param http The HTTP service to use to connect to the ARN server.
   * @param spec The i18n configuration with properties that may be omitted.
   * @param baseUrl The ARN project URL.
   */
  create(
    http: ArnHttpService,
    spec?: ArnI18nConfig,
    baseUrl?: string
  ): ArnI18nService {
    const config = this.createConfig(spec, baseUrl);
    return new ArnHttpI18nService(config, http);
  }
}
